import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-6 mb-6" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatCard = _resolveComponent("StatCard")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_StatCard, {
          label: "Consolidated Balance",
          icon: "media/icons/duotone/Shopping/Wallet2.svg",
          value: _ctx.dashboardData.overAllAvailableBalance,
          currencySymbol: _ctx.dashboardData.currency || ''
        }, null, 8, ["value", "currencySymbol"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_StatCard, {
          label: "PGI",
          period: "Total",
          icon: "media/icons/duotone/Home/Air-ballon.svg",
          value: _ctx.dashboardData.travelgc,
          currencySymbol: "",
          decimals: 0
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_StatCard, {
          label: "Product GC",
          period: "Total",
          icon: "media/icons/duotone/Shopping/Box2.svg",
          value: _ctx.dashboardData.productgc,
          currencySymbol: "",
          decimals: 0
        }, null, 8, ["value"])
      ])
    ])
  ]))
}